import axios from 'axios';

import * as utils from '../utils/utils.js';

export const updateNotifications = async (
    participant_id,
    notification_status
) => {
    var session_url =
        utils.backendUrl() +
        `/participant/notifications/?participant=${participant_id}&response=${notification_status}`;
    try {
        const response = await axios.get(session_url, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (err) {
        console.log(err.message);
        console.log(err.response);
        throw err;
    }
};
